import { IProjectState } from './ProjectState';
import { IProduct } from './ProductState';

export function lookupActiveProductReducer(state: IProjectState): IProduct | null {
  if (!state || !state.activeProduct) {
    return null;
  }
  return state.products.find(($) => $.id === state.activeProduct) || null;
}
